export default [
  {
    id: 1,
    question: "You frequently think to yourself...",
    answers: [
      {
        answer: "Is there anything she can't do?",
        value: ['e', 'f', 'j', 'k']
      },
      {
        answer: "No one is more caring and supportive",
        value: ['e', 'g']
      },
      {
        answer: "She's a force of nature",
        value: ['e', 'f', 'i', 'j', 'k']
      },
      {
        answer: "The world loves her as much as I do",
        value: ['i', 'j']
      },
      {
        answer: "How did she think of that?",
        value: ['h', 'j']
      }
    ]
  },
  // {
  //   question: "If she's not home, she's...",
  //   answers: [
  //     {
  //       answer: "Taking care of the family",
  //       value: ['e', 'g']
  //     },
  //     {
  //       answer: "Taking over the world",
  //       value: ['f', 'j', 'k']
  //     },
  //     {
  //       answer: "Drinking mimosas with friends",
  //       value: ['f', 'i']
  //     },
  //     {
  //       answer: "Taking herself to a movie",
  //       value: ['e', 'f', 'h']
  //     },
  //     {
  //       answer: "Creating a masterpiece",
  //       value: ['h', 'j']
  //     }
  //   ]
  // },
  {
    question: "When you're feeling down, she...",
    answers: [
      {
        answer: "Generously listens to your problems",
        value: ['e', 'g', 'i']
      },
      {
        answer: "Makes me laugh",
        value: ['i']
      },
      {
        answer: "Plots a plan to fix things",
        value: ['f', 'j', 'k']
      },
      {
        answer: "Makes me something to eat",
        value: ['g', 'h']
      },
      {
        answer: "Finds a way to build me up",
        value: ['i', 'k']
      }
    ]
  },
  {
    question: "Her idea of the perfect vacation is...",
    answers: [
      {
        answer: "A romantic sojourn along the Amalfi Coast",
        value: ['e', 'g']
      },
      {
        answer: "A ski trip in the French Alps",
        value: ['f', 'k']
      },
      {
        answer: "A couples cruise w/ six of your best friends",
        value: ['i']
      },
      {
        answer: "A week-long hike along the Appalachian Trail",
        value: ['e', 'h', 'k']
      },
      {
        answer: "A surprise trip to the Venice Biennale ",
        value: ['h', 'j']
      }
    ]
  },
  {
    question: "When you come down with something, she responds by...",
    answers: [
      {
        answer: "Riding it out with you",
        value: ['e', 'f', 'g']
      },
      {
        answer: "Calling the doctor and hounding him for advice",
        value: ['i', 'g']
      },
      {
        answer: "Periodically checking in with you while going about her day, because she knows you well enough to know you can handle yourself",
        value: ['f', 'k']
      },
      {
        answer: "Scouring WebMD for possible diagnoses and remedies",
        value: ['g', 'j', 'k']
      },
      {
        answer: "Making you the best chicken soup you've ever had",
        value: ['g', 'h']
      }
    ]
  },
  {
    question: "It's a lazy Sunday morning after a long weekend. She is...",
    answers: [
      {
        answer: "Curled up with you on the couch",
        value: ['e', 'g', 'h']
      },
      {
        answer: "At brunch drinking Bloody Marys with her friends",
        value: ['f', 'i']
      },
      {
        answer: "Making you an omelet",
        value: ['g']
      },
      {
        answer: "Already at the gym",
        value: ['f', 'k']
      },
      {
        answer: "Waking you up to run those errands you need to run",
        value: ['i', 'j']
      }
    ]
  },
  // {
  //   question: "When it comes to her leisure time, she...",
  //   answers: [
  //     {
  //       answer: "Tends to do whatever she feels like that day",
  //       value: ['f', 'h']
  //     },
  //     {
  //       answer: "Always stops to smell the roses",
  //       value: ['h']
  //     },
  //     {
  //       answer: "Wants to make sure everyone around her is enjoying theirs",
  //       value: ['g', 'i']
  //     },
  //     {
  //       answer: "Works hard to squeeze everything in",
  //       value: ['f', 'j']
  //     },
  //     {
  //       answer: "Makes up-to-the-minute plans to enjoy every minute",
  //       value: ['e', 'i', 'k']
  //     }
  //   ]
  // },
  {
    question: "You're taking a long drive or road trip. She...",
    answers: [
      {
        answer: "Lets you handle everything and sleeps in the passenger seat",
        value: ['i']
      },
      {
        answer: "Obsessively curates the music and podcasts",
        value: ['h', 'k']
      },
      {
        answer: "Maps everything out to a tee",
        value: ['e', 'j']
      },
      {
        answer: 'Is always up for the "scenic" route',
        value: ['j']
      },
      {
        answer: "Takes the wheel",
        value: ['e', 'f', 'g', 'k']
      }
    ]
  },
]
